import React from "react";
import CssClasses from "./LeftSectionPickers.css";
import Calendar from "../../Components/Navigation/Calendar/Calendar";
import MostPlayedOptions from "../../Components/Navigation/MostPlayedOptions/MostPlayedOptions";
import CategoryPicker from "../../Components/Navigation/CategoryPicker/CategoryPicker";
import LeaguePicker from "../../Components/Navigation/LeaguePicker/LeaguePicker";

const LeftSectionPickers = props => {
  return (
    <div className={CssClasses.container}>
      <Calendar />
      <MostPlayedOptions />
      <CategoryPicker />
      <LeaguePicker />
    </div>
  );
};

export default LeftSectionPickers;



// WEBPACK FOOTER //
// ./src/Containers/LeftSectionPickers/LeftSectionPickers.js